import { FaceManIcon } from './FaceManIcon';

/**
 * author: Google
 * id D41E7F40-FF48-422F-A64B-4908C6C10F00
 * name face-man
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-man.svg
 * tags
 * - People / Family 
 */
export const EmojiManIcon = FaceManIcon;
export default EmojiManIcon